import styled, { css } from 'styled-components';

import { FlexBox, system, SystemProps } from '@sternum/styled-system';
import { Colors } from '@sternum/web/components/theme/constants/Colors';
import { ct } from '@sternum/web/utils/theme';

import { DefaultInputHeight } from './Filters.consts';

import { RowTitleContainer, RowValueContainer } from '../QueryInterface.styles';

export const FiltersContainer = styled(FlexBox)`
  flex-direction: column;
  width: 100%;
  min-width: 0;
  outline: 1px solid ${ct({ Light: Colors.GreyDarkerMiddle, Dark: Colors.GreyDarkerMiddle })};
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  position: relative;

  &[data-error='true'] {
    outline: 1px solid ${ct({ Light: Colors.RedMiddle, Dark: Colors.RedMiddle })};
  }
`;

export const FiltersContainerForOnlyInput = styled(FlexBox)`
  flex-direction: column;
  width: 100%;
  min-width: 0;
  position: relative;
`;

export const Code = styled.div<SystemProps>`
  font-family: Fellix;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  word-break: break-all;
  width: 100%;
  word-wrap: break-word;
  min-width: 0px;
  overflow-y: auto;
  outline: 1px solid ${ct({ Light: Colors.GreyDarkerMiddle, Dark: Colors.GreyDarkerMiddle })};
  padding: 5px 12px;
  min-height: ${DefaultInputHeight}px;
  height: min-content;
  border: none;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: ${ct({ Light: Colors.White, Dark: Colors.White })};
  max-height: 100px;

  ${system}
`;

export const TextAreaContainer = styled.div`
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
`;

export const TextArea = styled.textarea<SystemProps>`
  color: ${Colors.Transparent};
  caret-color: ${Colors.Dark};
  background-color: ${Colors.Transparent};
  font-family: Fellix;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  outline: none;
  resize: none;
  border: none;
  padding: 5px 12px;
  margin: 0;
  width: 100%;
  word-break: break-all;
  border-radius: 0;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-height: 100px;

  ${system}
`;

export const CodeSpan = styled.span<{ $color: string; $outline: string; $textDecoration: string }>`
  color: ${({ $color }) => $color};
  outline: ${({ $outline }) => $outline};
  word-break: 'break-all';
  word-wrap: 'break-word';
  min-width: '0px';
  text-decoration: ${({ $textDecoration }) => $textDecoration};
  text-underline-offset: 3px;
`;

export const FilterTitleContainer = styled(RowTitleContainer)<{ $isClickable?: boolean }>`
  ${({ $isClickable }) =>
    $isClickable &&
    css`
      cursor: pointer;
    `}
`;

export const FiltersRowValueContainer = styled(RowValueContainer)`
  border: 1px solid ${ct({ Dark: Colors.Transparent, Light: Colors.Transparent })};
`;

export const FilterSpacer = styled.div<{ height: number }>`
  height: ${(props) => props.height}px;
`;

export const ArrowContainer = styled.div<{ flipped: boolean }>`
  transform: rotate(${(props) => (props.flipped ? 0 : 180)}deg) translate(0, 2px);
`;
